import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ChatCurtain extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    const show = props.show;

    this.state = {
      show,
    };
  }

  /**
   * Handle curtain click.  Dismisses it for now.
   * @return
   */
  handleClick() {
    this.setState({ show: false });
  }

  render() {
    if (!this.state.show) {
      return null;
    }

    return (
      <div
        className="chat-curtain"
        onClick={this.handleClick}
        title="Click to dismiss"
      >
        {this.props.children}
      </div>
    );
  }
}

ChatCurtain.defaultProps = {
  show: false,
};

ChatCurtain.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
};

export default ChatCurtain;
